import * as Yup from 'yup';

export const DashboardSchema = Yup.object().shape({
    name: Yup.string()
        .min(1, 'Namn är för kort!')
        .max(45, 'Namn är för långt!')
        .required('Namn saknas!')
});
